import React from 'react'
import { Icon } from './icon';
import './points.css';

interface IPoint {
    icon         : string;
    header       : string;
    description? : string;
}

interface IPoints {
    heading?     : string;
    description? : string
    points       : IPoint[];
}

interface Props {
    children : IPoints;
}

export class Points extends React.Component<Props> {

    render() {
        return (
            <div className="points">
            { this.props.children.heading && 
                <h2>{ this.props.children.heading }</h2>
            }
            { this.props.children.description !== undefined && 
              <p className="point-desc">{ this.props.children.description }</p>
            }

            <ul>
                { this.renderPoints(this.props.children.points) }
            </ul>
            </div>
        );
    }

    renderPoint(point : IPoint, id : number) : React.JSX.Element
    {
        return (
            <div className="point" key={"points" + id}>
                <Icon>{ point.icon }</Icon>
                <div className="point-text">
                    <p className="point-head">{ point.header }</p>
                    { point.description !== undefined && 
                      <p className="point-desc">{ point.description }</p>
                    }
                </div>
            </div>);
    }

    renderPoints(points : IPoint[]) : React.JSX.Element[]
    {
        let list : React.JSX.Element[] = [];

        for (let i = 0; i < points.length; i++) {
            list.push(this.renderPoint(points[i], i));
        }

        return list;
    }
}

